import React, { useState } from "react";
import { FiFilter } from "react-icons/fi";
import Payment from "./TempFiveTab/payment";
import Funding from "./TempFiveTab/funding";
import { useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";

const TempFive = () => {
  const [activeTab, setActiveTab] = useState("payment");

  const handleSelectedtab = (tab: string) => {
    setActiveTab(tab);
  };

  const viewWallet: any = useAppSelector(
    (store: RootState) => store.user.viewWallet
  );




  return (
    <div className="px-3">
      <div className="flex justify-between mb-4">
        <div className="flex gap-10 text-[#88087B] items-center">
          <p className="font-roboto text-3xl font-medium leading-normal">
          {viewWallet?.firstName}{" "}{viewWallet?.lastName}
          </p>
          <p className="border-l-2 border-[#000] px-2 font-roboto text-lg font-medium leading-normal">
            Rating: 4.8
          </p>
          <p className="border border-[#000]  px-2 font-roboto text-lg font-medium leading-normal">
            Wallet Balance: ₦ {viewWallet?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div>
        <FiFilter size={20} className="text-[#88087B]" />
      </div>
      <div className="flex gap-10">
        <p
          className={`bg-[#fff] rounded-3xl p-2 cursor-pointer ${
            activeTab === "payment" ? "border-[#88087B] border" : ""
          }`}
          onClick={() => handleSelectedtab("payment")}
        >
          Payment History
        </p>
        <p
          className={`bg-[#fff] rounded-3xl p-2 cursor-pointer ${
            activeTab === "funding" ? "border-[#88087B] border" : ""
          }`}
          onClick={() => handleSelectedtab("funding")}
        >
          Funding History
        </p>
      </div>
      {activeTab === "payment" && <Payment />}
      {activeTab === "funding" && <Funding />}
    </div>
  );
};

export default TempFive;
